import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { WalletModelShort } from '@root/entities/wallet/ui'
import { Drawer } from '@root/shared/ui-kit'

import { AssetsManagementBody } from '../common/assets-management-body'

import type { WalletModel } from '@root/entities/wallet/atoms'
import type { ClassNameProps } from '@root/shared/react'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type AssetsManagementDrawerProps = {
  wallet: WalletModel
} & DrawerControlProps &
  ClassNameProps

export const AssetsManagementDrawer: React.FC<AssetsManagementDrawerProps> = ({
  open,
  wallet,
  onOpenChange,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      className={className}
      open={open}
      onOpenChange={onOpenChange}
      title={t('wallet.manage-assets')}
    >
      <Body>
        <WalletModelShort
          size="md"
          wallet={wallet}
          css={css`
            justify-content: center;
          `}
        />
        <AssetsManagementBody
          wallet={wallet}
          css={css`
            height: 100%;
          `}
        />
      </Body>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
  height: 100%;
`

const Body = styled.div``
